import { coreUsersByIdNotificationPreferencesGetAsyncSlice } from './get';
import { coreUsersByIdNotificationPreferencesPatchAsyncSlice } from './patch';

export const { requestGetCoreUsersByIdNotificationPreferences, resetGetCoreUsersByIdNotificationPreferences } =
	coreUsersByIdNotificationPreferencesGetAsyncSlice.asyncActionCreators;

export const { requestPatchCoreUsersByIdNotificationPreferences, resetPatchCoreUsersByIdNotificationPreferences } =
	coreUsersByIdNotificationPreferencesPatchAsyncSlice.asyncActionCreators;
